// The default-resolving layer over
// `data/harness/agent-events/use-agent-event-stream.ts`.
//
// Same shape as `stream/use-agent-stream.ts`: `eventsPath` resolves the
// ml-scribe origin, `streamHeaders` mints the auth + client-identity headers,
// and both are re-applied here from `agentHarnessClient`.
import { useAgentEventStream as useAgentEventStreamCore } from '../../../data';

import { agentHarnessClient } from '../client';
import { streamHeaders } from '../stream/stream-http';

export type {
  AgentEventStreamState,
  AgentEventStreamStatus,
  UseAgentEventStreamOptions,
} from '../../../data';

type CoreOptions = Parameters<typeof useAgentEventStreamCore>[0];

export const useAgentEventStream = ({
  eventsPath = agentHarnessClient.eventsPath,
  streamHeaders: headersFactory = streamHeaders,
  ...rest
}: Omit<CoreOptions, 'eventsPath' | 'streamHeaders'> &
  Partial<Pick<CoreOptions, 'eventsPath' | 'streamHeaders'>>) =>
  useAgentEventStreamCore({ ...rest, eventsPath, streamHeaders: headersFactory });
